import type { NetworkingTaskStatus } from '../../lib/networkingTasks';

export type TaskStatusConfirmCopy = {
  title: string;
  body: string;
  confirmLabel: string;
  /** Tailwind classes for the confirm button */
  confirmClass: string;
};

export function taskStatusConfirmCopy(nextStatus: NetworkingTaskStatus): TaskStatusConfirmCopy {
  switch (nextStatus) {
    case 'in_progress':
      return {
        title: 'Start this task?',
        body: 'This will mark the task as in progress — you are actively working on it.',
        confirmLabel: 'Start task',
        confirmClass: 'bg-sky-600 hover:bg-sky-700 text-white',
      };
    case 'done':
      return {
        title: 'Mark as done?',
        body: 'This will mark the task complete and remove it from your open queue.',
        confirmLabel: 'Mark done',
        confirmClass: 'bg-emerald-600 hover:bg-emerald-700 text-white',
      };
    case 'skipped':
      return {
        title: 'Skip this task?',
        body: 'This will archive the task as skipped — use when nothing actionable remains.',
        confirmLabel: 'Skip task',
        confirmClass: 'bg-gray-700 hover:bg-gray-800 dark:bg-gray-600 dark:hover:bg-gray-500 text-white',
      };
    case 'pending':
      return {
        title: 'Reopen this task?',
        body: 'This will return the task to your open queue as pending.',
        confirmLabel: 'Reopen task',
        confirmClass: 'bg-amber-600 hover:bg-amber-700 text-white',
      };
    default:
      return {
        title: 'Update this task?',
        body: 'Confirm you want to change the task status.',
        confirmLabel: 'Confirm',
        confirmClass: 'bg-emerald-600 hover:bg-emerald-700 text-white',
      };
  }
}
